import { Car } from "./car";
import { User } from "./user";

export class Dealer {
  _id: string;
  employees: Array<User>;
  cars: Array<Car>;
  url: string;
  name: string;
  // new change - here add list1 and list2 id for dealer
  list1: string;
  list2: string;
  list1_name: string;
  list2_name: string;
  company: string;
  from_name: string;
  from_email: string;
  subject: string;
  language: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  permission_reminder: string;
  email_type_option: boolean;
  payment_method: string;
  logo: string;
  phone: string;
  dealerCode: string;
  serviceAgreementEnabled: boolean;
  usedCarEnabled: boolean;
  tyreHotelEnabled: boolean;
  prolongingsEnabled: boolean;
  serviceIntervalsEnabled: boolean;
  monitorKmEnabled: boolean;
  newCarEmailFieldDisabled: boolean;
  usedCarEmailFieldDisabled: boolean;
  tyreHotelEmailFieldDisabled: boolean;
  prolongingsEmailFieldDisabled: boolean;
  serviceIntervalsEmailFieldDisabled: boolean;
  monitorKmEmailFieldDisabled: boolean;
  usedCarsPeriodEnabled: boolean;
  usedCarPeriodCheapestEnabled: boolean;
  usedCarPeriodLongestEnabled: boolean;
  usedCarPeriodExtraYearEnabled: boolean;
  tyreMountingPrice: number;
  tyrePaymentTerms: string;
  tyreDataNote: string;
  tyreQualityNote: string;
  tyreChoiceNote: string; 
  maxKms: number;
  maxYears: number;
  usedCarPaymentTerms: string;
	usedCarAlternativeLenghtNote: string;
	usedCarYearKmNote: string;
	prolongingsPaymentTerms: string; 
	prolongingsYearKmNote: string;
  monitorKmOverExceed: number;
  monitorKmUnderExceed: number;
  monitorKmOverPercentage: number;
  monitorKmUnderPercentage: number;
  monitorKmShowOnlyOver: boolean;
}



// WEBPACK FOOTER //
// ./src/app/_models/dealer.ts